<template>
  <div class="input-wrapper">
    <div class="input-container">
      <!-- 输入区域 -->

      <div class="input-item">
        <span class="input-label">平台：</span>
        <el-input
          v-model="platform_name"
          placeholder="请输入平台"
          clearable
          style="width: 600px"
          :disabled="true"
        ></el-input>
      </div>
      <div class="input-item">
        <span class="input-label">cookie：</span>
        <el-input
          v-model="input1"
          placeholder="请输入cookie账号"
          clearable
          style="width: 600px"
        ></el-input>
      </div>
      
      <div class="input-item">
        <div class="input-label">账号昵称：</div>
        <el-input
          v-model="input2"
          placeholder="请输入账号昵称"
          clearable
          style="width: 600px"
        ></el-input>
      </div>

      <!-- 提交按钮 -->
      <div class="submit-btn">
        <el-button type="primary" @click="addItem">提交</el-button>
      </div>

      <!-- 数据表格 -->
      <el-table 
        :data="list" 
        style="width: 100%;height: 800px; margin-top: 20px"
        stripe
        border>
        <el-table-column prop="id" label="id" width="120"></el-table-column>
        <el-table-column prop="platform_name" label="平台" width="120"></el-table-column>
        <el-table-column prop="account_name" label="账号" width="150"></el-table-column>
  
        <el-table-column prop="cookies" label="Cookie" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" width="120">
           <template #default="{ row }">
            <el-switch
              v-model="row.status"
              active-text="有效"
              inactive-text="无效"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="时间" width="180"></el-table-column>
        <el-table-column label="操作" width="120">
          <template #default="{ row }">
            <el-button 
              size="mini" 
              type="danger" 
              @click="deleteItem(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

import { douyin_count,douyin_count2,delete_count } from '@/api/douyin';
export default {
  data() {
    return {
      platform_name: 'xhs',
      input1: '',
      input2: '',
      list: [],
      statusType: {
        '未开始': 'info',
        '进行中': 'warning',
        '已完成': 'success'
      }
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await douyin_count2({}); // 调用接口
        if (response.data) {
          // 过滤出 platform_name 为 'dy' 的数据
          const filteredData = response.data.filter(item => item.platform_name === 'xhs');
          // 将过滤后的数据映射到表格需要的结构
          this.list = filteredData.map(item => ({
            id: item.id,
            platform_name: item.platform_name,
            account_name: item.account_name,
            cookies: item.cookies,
            status: true, // 默认状态为有效
            time: new Date().toLocaleString() // 添加时间字段
          }));
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败，请检查网络连接');
      }
    },
    async addItem() {
      if (!this.input1 || !this.input2) {
        this.$message.warning('请填写完整信息')
        return
      }

      try {
        const params = {
          platform_name: this.platform_name,
          cookies: this.input1,
          account_name: this.input2
        }

        // 调用接口
        const response = await douyin_count(params)
        
        // 接口调用成功后处理
        if (response.status === 200) { // 根据实际返回结构判断
          this.list.push({
            platform_name: params.platform_name,
            account_name: params.account_name,
            cookies: params.cookies,
            status: true,
            time: new Date().toLocaleString()
          })
          
          this.$message.success('提交成功')
          this.input1 = ''
          this.input2 = ''
        } else {
          this.$message.success('提交成功')
        }
      } catch (error) {
        console.error('提交出错:', error)
        this.$message.error('请求失败，请检查网络连接')
      }
    },
    async deleteItem(id) {
      try {
        // 调用删除接口
        const response = await delete_count(id);
        if (response.status === 200) {
          // 从表格中移除对应的记录
          this.list = this.list.filter(item => item.id !== id);
          this.$message.success('删除成功');
        }
      } catch (error) {
        console.error('删除出错:', error);
        this.$message.error('删除失败，请检查网络连接');
      }
    }
  
  }
}
</script>

<style scoped>
.input-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px 0;
}

.input-container {
  width: 100%;
  max-width: 1000px;
  padding: 30px;
  background: #f5f7fa;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

.input-item {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.input-label {
  margin-right: 15px;
  font-size: 14px;
  color: #606266;
  min-width: 80px;
  text-align: right;
}

.submit-btn {
  text-align: center;
  margin: 25px 0;
}

/* 调整表格样式 */
.el-table {
  margin-top: 30px;
}

.el-table::before {
  height: 0; /* 去除默认的底部边框 */
}

/* 操作按钮样式 */
.el-button--mini {
  padding: 5px 10px;
}

.el-switch {
  margin-left: 8px;
}

/* 调整开关文字间距 */
.el-switch__label {
  margin: 0 4px;
  color: #606266;
}
.el-switch__label.is-active {
  color: #409EFF;
}
</style>